// W7 (owner 2026-10-30): the Runs tab of a campaign from the events in ClickHouse: one row per person (run) with the
// block it last left and the exit it took, 50 a page by a cursor, filters; limit 5,000 for an export. Lead codes only.
import { z } from 'zod'
import { IsoDateTime } from './common'

const count = z.number().int().min(0)

export const CampaignRunRow = z.object({
  run_id: z.string(),
  lead_code: z.string(),
  at: IsoDateTime.describe('the last step taken'),
  block: z.string().describe('the block last left (or "end")'),
  exit: z.string().describe('the exit taken there: pass / fail, press_1, link, next, end …'),
  outcome: z.string().describe('how the run ended, or empty while it runs'),
  message_status: z.string().describe('the last status of the last message, or empty'),
  digit: z.string().describe('the IVR key pressed, or empty'),
  steps: count.describe('blocks passed'),
})
export type CampaignRunRow = z.infer<typeof CampaignRunRow>

export const CampaignRunsQuery = z.object({
  block: z.string().optional().describe('only runs whose last block is this one'),
  exit: z.string().optional(),
  message_status: z.string().optional(),
  lead_code: z.string().optional().describe('a lead code, or its start'),
  after: z.string().optional().describe('the cursor of the last row shown (CampaignRunsPage.next)'),
  limit: z.number().int().min(1).max(5000).optional().describe('50 by default; 5,000 for an export'),
})
export type CampaignRunsQuery = z.infer<typeof CampaignRunsQuery>

export const CampaignRunsPage = z.object({
  source: z.enum(['clickhouse', 'none']),
  rows: z.array(CampaignRunRow),
  next: z.string().nullable().describe('the cursor for the older rows; null = no more'),
})
export type CampaignRunsPage = z.infer<typeof CampaignRunsPage>
